import { GET_USER_ADDRESSES } from "../../../../enums/Profile/profile";

export const getUserAddressesAction = (data) => {
    return {
        type: GET_USER_ADDRESSES,
        payload: data,
    };
};
